import './GeneralCardCompleteRound.css';
import React from 'react';
import { canUseDOM, get, getPageThemeColors, getColorByTheme } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { DefaultCards } from './components/DefaultCards';
import { DropCards } from './components/DropCards';
import { isNil } from '../../utils/IsNil';
export let EGeneralCardCompleteRoundTypes = /*#__PURE__*/function (EGeneralCardCompleteRoundTypes) {
  EGeneralCardCompleteRoundTypes["Default"] = "Default";
  EGeneralCardCompleteRoundTypes["Drop"] = "Drop";
  return EGeneralCardCompleteRoundTypes;
}({});
export const GeneralCardCompleteRound = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.info('GeneralCardCompleteRound component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [GeneralCardCompleteRound component is empty: please provide data source]");
    }
    return null;
  }
  const cardVariant = get(params, 'variant');
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const generalCardsIconMap = {
    Default: /*#__PURE__*/React.createElement(DefaultCards, {
      fields: fields,
      params: params
    }),
    Drop: /*#__PURE__*/React.createElement(DropCards, {
      fields: fields,
      params: params
    })
  };
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const activeColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const activePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedActiveColor = activePageThemeColor ? activePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const variables = BackgroundColorHex ? {
    '--general-card-complete-round-color': BackgroundColorHex,
    '--general-card-complete-round-active-color': activeColorHex,
    '--general-card-complete-round-text-color': ColorHex
  } : {
    '--general-card-complete-round-color': selectedPrimaryColor,
    '--general-card-complete-round-active-color': selectedActiveColor,
    '--general-card-complete-round-text-color': getColorByTheme(selectedPrimaryColor)
  };
  if (isNil(generalCardsIconMap[cardVariant])) {
    console.warn(`component with "${cardVariant}" variant is not defined, try to use of this options ${Object.values(EGeneralCardCompleteRoundTypes)}`);
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, generalCardsIconMap[cardVariant]);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    anchorUrlParameter,
    style,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "c1cdj0mc" : "czc1gm9";
  const ltrStyles = isDetSite ? "l1pie3qg" : "lzv23s8";
  const rtlStyles = isDetSite ? "rm8xlg6" : "r1ie1ni3";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export default GeneralCardCompleteRound;